import { InputSize, inputSizes } from '../inputSizes';
import { token } from 'odyssey';
import styled, { css } from 'styled-components';

export const StyledTextarea = styled.textarea<{ hasError?: boolean; size?: InputSize }>`
  width: 100%;
  max-width: ${({ size }) => (size ? `${inputSizes[size]}px` : '100%')};
  min-height: 10em;
  padding: ${token('space-4')};
  display: block;
  line-height: inherit;
  resize: vertical;
  border-radius: ${token('border-radius-md')};
  border: solid 1px ${token('color-grey-3-neutral')};
  outline: none;

  &:focus {
    border-color: ${token('color-grey-1-neutral')};
  }

  &:disabled {
    border-color: ${token('color-grey-4-neutral')};
  }

  ${({ hasError }) =>
    hasError &&
    css`
      border-color: ${token('color-negative-semantic')};
    `}
`;
